<template>
  <div :style="{ height: `${height}px` }"></div>
</template>

<script>
export default {
  props: {
    height: { type: String, required: true }
  }
};
</script>



// WEBPACK FOOTER //
// Spacer.vue?3d2934dc